__turbopack_context__.v({
  "frame": "DeEOoG_frame",
  "item": "DeEOoG_item",
  "layer": "DeEOoG_layer",
  "list": "DeEOoG_list",
  "listWrap": "DeEOoG_listWrap",
  "photo": "DeEOoG_photo",
  "pin": "DeEOoG_pin",
  "root": "DeEOoG_root",
  "side": "DeEOoG_side",
  "wrap": "DeEOoG_wrap",
});
